import HeadSection from "../Components/CMS/head-section";
import CmsBenefits from "../Components/CMS/cms-benefits";
import CmsProcess from "../Components/CMS/cms-process";
import MainLayout from "../layout/main-layout";
import CmsContactSection from "../Components/CMS/cms-contact-section";
import { useRef } from "react";

function ContentManagementSystem() {
  const contactRef = useRef<HTMLDivElement>(null);
  
    const handleScrollToContact = () => {
      contactRef.current?.scrollIntoView({ behavior: "smooth" });
    };
  return (
    <div>
      <MainLayout>
        <HeadSection onScroll={handleScrollToContact} />
        <CmsBenefits />
        <CmsProcess />
        <CmsContactSection contactRef={contactRef} />
      </MainLayout>
    </div>
  );
}

export default ContentManagementSystem;
